import { useEffect } from "react";
import { GridAnswers } from "./types";
import { writeCachedAnswers } from "./storage";

// Debounced localStorage autosave as a local safety net; the server draft is the durable copy.
export const useAutosave = (key: string | null, answers: GridAnswers, enabled: boolean): void => {
  useEffect(() => {
    // key is null when the tenant can't be identified → caching disabled.
    if (!enabled || !key) return undefined;
    const timer = setTimeout(() => writeCachedAnswers(key, answers), 500);
    return () => clearTimeout(timer);
  }, [key, answers, enabled]);
};
